module.exports = __webpack_public_path__ + "1a98335a74daef477081bfb23efb9c15.jpg";